var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.459,
    height: 39.761,
    viewBox: "0 0 122.459 39.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    width: 122.459,
    height: 39.761,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163-2",
    "data-name": "Group 163",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M35.39,13.515l-.3-.252L29.565,8.648,20.649,1.2l-.8-.667a3.594,3.594,0,0,0-3.763,0l-.8.667L.85,13.263l-.3.252a1.93,1.93,0,0,0-.173,2.493l.006.009.136.161h0a1.929,1.929,0,0,0,2.531.252l.221-.184L15.4,6.113l.218-.182c.024-.022.05-.043.077-.065l0,0a3.6,3.6,0,0,1,4.543,0l0,0c.027.023.053.043.077.065l.218.182,9.025,7.541,3.1,2.592.221.184a1.929,1.929,0,0,0,2.531-.252h0l.136-.161.006-.009a1.93,1.93,0,0,0-.173-2.493",
    transform: "translate(0 0)",
    fill: "#372198"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M31.03,20.84l0,0-.714-.6-8.768-7.327-.262-.218-.187-.156-.005,0-.168-.141-.008-.006a3.574,3.574,0,0,0-4.4,0l-.008.006-.168.141c-.063.056-.123.112-.18.173L16.15,12.7,6.406,20.837l0,0a1.925,1.925,0,0,0-.342,2.6l.193.231a1.928,1.928,0,0,0,2.6.141l7.307-6.1.145-.121,0,0c.077-.07.158-.136.242-.2a3.579,3.579,0,0,1,4.323,0c.083.065.164.131.242.2l0,0,.145.121,7.307,6.1a1.918,1.918,0,0,0,1.226.44,1.93,1.93,0,0,0,1.378-.58l.194-.231a1.927,1.927,0,0,0-.342-2.6",
    transform: "translate(-0.747 -1.524)",
    fill: "#372198"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M22.9,29.683A2.393,2.393,0,0,0,20.286,27.6a2.4,2.4,0,0,0-2.615,2.087v4.641H22.9Z",
    transform: "translate(-2.315 -3.615)",
    fill: "#372198"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M26.453,44.842H12.236A1.738,1.738,0,0,1,10.5,43.1V40.526a1.738,1.738,0,0,1,3.476,0v.839H24.715v-.839a1.738,1.738,0,0,1,3.476,0V43.1a1.739,1.739,0,0,1-1.738,1.738",
    transform: "translate(-1.375 -5.081)",
    fill: "#372198"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M71.475,32.834C71.044,30.3,68.994,28.7,66.116,28.7s-4.949,1.6-5.38,4.136a5.914,5.914,0,0,0,.1,2.531,5.077,5.077,0,0,0,5.281,3.726,5.064,5.064,0,0,0,5.261-3.726,5.93,5.93,0,0,0,.1-2.531m-5.359,3.889a2.391,2.391,0,0,1-2.227-1.357,3.307,3.307,0,0,1-.311-1.443,3.344,3.344,0,0,1,.169-1.089,2.492,2.492,0,0,1,4.738,0,3.321,3.321,0,0,1,.169,1.089,3.212,3.212,0,0,1-.318,1.443,2.389,2.389,0,0,1-2.22,1.357",
    transform: "translate(-7.944 -3.759)",
    fill: "#3daefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M54.166,36.9A2.544,2.544,0,0,1,51.628,34.1a2.541,2.541,0,0,1,2.538-2.8,2.388,2.388,0,0,1,1.961.939,1.329,1.329,0,0,0,1.051.566h.188a1.343,1.343,0,0,0,1.028-2.213,5.471,5.471,0,0,0-4.228-1.717c-3.281,0-5.472,2.065-5.472,5.19,0,3.1,2.192,5.2,5.472,5.2a5.476,5.476,0,0,0,4.212-1.717,1.344,1.344,0,0,0-1.029-2.214h-.066a1.308,1.308,0,0,0-1.091.536A2.383,2.383,0,0,1,54.166,36.9",
    transform: "translate(-6.378 -3.782)",
    fill: "#3daefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M84.61,38.406h-2.9V36.912a3.723,3.723,0,0,1-3.22,1.609c-2.9,0-4.808-2.1-4.808-5.244,0-3.1,1.893-5.169,4.733-5.169a3.835,3.835,0,0,1,3.3,1.609V24.357h2.9Zm-2.9-5.054a2.57,2.57,0,0,0-2.538-2.822A2.608,2.608,0,0,0,76.6,33.352a2.569,2.569,0,1,0,5.113,0",
    transform: "translate(-9.652 -3.191)",
    fill: "#3daefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M97.946,35.5h.036A7.419,7.419,0,0,0,98,34.719a5.465,5.465,0,0,1-.057.778m-10.2-.707c0-.184.007-.368.014-.552a3.949,3.949,0,0,0-.022.41.82.82,0,0,0,.008.142",
    transform: "translate(-11.493 -4.485)",
    fill: "#3daefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M87.761,35.362c0,.091,0,.183.008.282H87.8c-.015-.092-.021-.184-.036-.282",
    transform: "translate(-11.496 -4.632)",
    fill: "#3daefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M97.948,33.089a5.137,5.137,0,0,0-10.1-.325,1.254,1.254,0,0,0-.028.226c-.028.169-.043.346-.057.523s-.013.368-.013.552c0,.141,0,.282.013.424.015.1.022.19.036.282a4.855,4.855,0,0,0,5.084,4.313,5.076,5.076,0,0,0,4.25-2.093,4.719,4.719,0,0,0,.65-1.414H94.738a2.5,2.5,0,0,1-1.131,1,1.777,1.777,0,0,1-1.435.014,2.639,2.639,0,0,1-1.5-1.824h7.275A5.477,5.477,0,0,0,98,33.994v-.07a6.291,6.291,0,0,0-.056-.834m-7.46-.043a2.131,2.131,0,0,1,2.256-2.213.825.825,0,0,1,.134.007.782.782,0,0,1,.127-.007,2.122,2.122,0,0,1,2.249,2.213Z",
    transform: "translate(-11.494 -3.76)",
    fill: "#3daefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M109.825,38.989l-2.2-6.722-2.177,6.722h-2.916l-3.73-10.167,2.972-.02,2.272,7.29,2.2-7.29h2.858l2.234,7.29,2.234-7.29h2.878L112.74,38.989Z",
    transform: "translate(-12.943 -3.773)",
    fill: "#3daefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M125.182,37.78a3.92,3.92,0,0,1-3.2,1.324c-2.178,0-3.5-1.324-3.5-3.181,0-1.912,1.382-3.048,3.881-3.067h2.8v-.189c0-1.079-.72-1.7-2.12-1.7a6.452,6.452,0,0,0-3.029.89l-.91-2.007a9.56,9.56,0,0,1,4.6-1.174c2.727,0,4.3,1.363,4.317,3.654l.019,6.646h-2.859Zm-.019-2.292V34.58h-2.292c-1.117,0-1.666.342-1.666,1.155,0,.777.607,1.288,1.59,1.288a2.254,2.254,0,0,0,2.367-1.534",
    transform: "translate(-15.52 -3.756)",
    fill: "#3daefe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_393",
    "data-name": "Rectangle 393",
    width: 2.916,
    height: 14.049,
    transform: "translate(114.375 21.166)",
    fill: "#3daefe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_394",
    "data-name": "Rectangle 394",
    width: 2.916,
    height: 14.049,
    transform: "translate(119.543 21.166)",
    fill: "#3daefe"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.20e35ebb0b83b7b1894411d7a93fee9e.svg";
export { ForwardRef as ReactComponent };